<script>
import Chevron from '@/components/icons/Chevron'
import Close from '@/components/icons/Close'
import FileWrapper from '@/components/modules/Files/layouts/FileWrapper'

const transitionLookup = {
  leave: {
    next: 'slideOutLeft',
    previous: 'slideOutRight'
  },
  enter: {
    next: 'slideInRight',
    previous: 'slideInLeft'
  }
}

export default {
  name: 'LayoutFullscreen',
  inheritAttrs: false,
  data () {
    return {
      panning: false,
      transform: '',
      slidestartx: '0px',
      previousLocation: '',
      nextLocation: '',
      activeTransition: ''
    }
  },
  methods: {
    close () {
      this.activeTransition = ''
      this.$nextTick(() => {
        this.$router.push({ query: { fullscreen: undefined } })
      })
    },
    previous () {
      if (this.previousLocation) {
        this.activeTransition = 'previous'
        // set transition before router changes requires waiting for a re-render to make the transition change take effect
        this.$nextTick(() => {
          this.$router.push({ path: this.previousLocation, query: { fullscreen: true } })
        })
      }
    },
    next () {
      if (this.nextLocation) {
        this.activeTransition = 'next'
        // set transition before router changes requires waiting for a re-render to make the transition change take effect
        this.$nextTick(() => {
          this.$router.push({ path: this.nextLocation, query: { fullscreen: true } })
        })
      }
    },
    onSwipe (event) {
      switch (Math.sign(event.deltaX)) {
        case 1:
          this.previous()
          break
        case -1:
          this.next()
          break
      }
    },
    onPan (event) {
      this.panning = true
      this.slidestartx = event.deltaX + 'px'
      this.transform = 'translateX(' + event.deltaX + 'px)'
    },
    onPanend (event) {
      this.panning = false
      this.transform = ''
      if (event.deltaX < -100) {
        this.next()
      } else if (event.deltaX > 100) {
        this.previous()
      }
    }
  },
  render (createElement) {
    const files = this.$slots.default

    return createElement('div',
      {
        directives: [
          {
            name: 'hammer',
            value: this.onSwipe,
            arg: 'swipe',
            modifiers: {
              left: true,
              right: true
            }
          },
          {
            name: 'hammer',
            value: this.onPan,
            arg: 'pan',
            modifiers: {
              horizontal: true
            }
          },
          {
            name: 'hammer',
            value: this.onPanend,
            arg: 'panend'
          }
        ]
      },
      [
        files.map((f, i) => {
          const isActiveVnode = f.data.key === this.$route.path
          if (isActiveVnode) {
            this.previousLocation = (files[i - 1] && files[i - 1].data.key) || files[files.length - 1].data.key
            this.nextLocation = (files[i + 1] && files[i + 1].data.key) || files[0].data.key
          }
          return createElement(
            FileWrapper,
            {
              props: {
                transitionProps: {
                  'enter-active-class': transitionLookup.enter[this.activeTransition],
                  'leave-active-class': transitionLookup.leave[this.activeTransition]
                }
              },
              class: {
                panning: this.panning,
                file: true,
                fullscreen: true
              },
              style: {
                '--slide-start-x': this.slidestartx,
                transform: this.transform
              }
            },
            [isActiveVnode ? f : undefined])
        }),
        createElement('div', { class: 'close', on: { click: this.close } }, [createElement(Close, { props: { color: 'white', size: 'm' } })]),
        this.$slots.default.length > 1 && createElement('div', { class: 'previous', on: { click: this.previous } }, [createElement(Chevron, { props: { color: 'white', size: 'xl', rotate: 180 } })]),
        this.$slots.default.length > 1 && createElement('div', { class: 'next', on: { click: this.next } }, [createElement(Chevron, { props: { color: 'white', size: 'xl' } })])
        /* , propEditor */
      ])
  }
}
</script>

<style lang="scss" scoped>
/deep/ > .previous,
/deep/ .next {
  position: absolute;
  top: 47vh;
}

/deep/ > .previous {
  left: 1vw;
}

/deep/ > .next {
  right: 1vw;
}

/deep/ > .close {
  position: absolute;
  top: 2vh;
  right: 2vw;
}
</style>
